import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { Layout, enums } from '@cheetahdigital/console-kit-cx';
import { useState, useEffect } from 'react';
import { useTranslation } from '../../../locales/i18n.js';
import '../../../node_modules/classnames/index.js';
import Modal from '../../../shared/components/Modal/index.js';
import 'semantic-ui-react';
import 'react-dom';
import Button from '../../../shared/elements/Button/index.js';
import Label from '../../../shared/elements/Label/index.js';
import Headline from '../../../shared/elements/Headline/index.js';
import Cookie from '../../../shared/utils/cookie.js';

var ImpersonateEndModal = function () {
    var t = useTranslation()[0];
    var _a = useState(false), isImpersonationEnded = _a[0], setIsImpersonationEnded = _a[1];
    useEffect(function () {
        var currentImpersonateUser = Cookie.getCookie("cid_impersonate");
        if (Cookie.getCookie("cid_impersonate")) {
            var interval_1 = window.setInterval(function () {
                if (currentImpersonateUser !== Cookie.getCookie("cid_impersonate")) {
                    clearInterval(interval_1);
                    setIsImpersonationEnded(true);
                }
            }, 1000);
            return function () { return clearInterval(interval_1); };
        }
    }, []);
    return (jsx(Fragment, { children: jsx(Modal, __assign({ isActive: isImpersonationEnded, hasCloseIcon: false }, { children: jsxs(Layout, { children: [jsx(Layout.Row, { children: jsx(Headline, __assign({ size: "huge", isUppercase: false, isGapless: true }, { children: t("impersonated-session-ended") }), void 0) }, void 0), jsx(Layout.Row, { children: jsx(Layout.Column, { children: jsx(Label, { children: t("impersonated-session-ended-description") }, void 0) }, void 0) }, void 0), jsx(Layout.Row, { children: jsx(Layout.Column, __assign({ textAlign: enums.textAlignments.RIGHT }, { children: jsx(Button, __assign({ isSolid: true, onClick: function () { return window.location.reload(); } }, { children: t("ok") }), void 0) }), void 0) }, void 0)] }, void 0) }), void 0) }, void 0));
};

export { ImpersonateEndModal as default };
